/**
 * all states from store
 */
export default {
  menu_param: {},
  links: [],
  alcadas: [],
  show_alcadas: {
    state: false,
    mini_state: true
  },
  tour_presentations: {
    terms: null,
    show_up: null,
    new_alcada: null,
    dashboard: null
  },
  show_card_stores: false,
  component_or_element: {
    q_menu_store_header: {
      ref: null,
      persistent: false,
      show: false,
      opacity: 1
    },
    q_menu_store_cluster: {
      ref: null,
      persistent: false,
      show: false,
      opacity: 1
    },
    alcadas: {
      ref: null,
      show: false,
      mini_state: true
    }
  }
};
